import { postWithToken } from 'api/network';
import { put, takeEvery, select } from 'redux-saga/effects';
import { selectedModuleSelector } from '../../../store/selectors';
import {
  appNotify,
  createAssumptionGroup,
  setGroupsAreLoading,
  setSelectedGroupId,
  setSelectedGroupIsOpen,
  setSelectedModule,
} from '../../../store/actions';

export function* createAssumptionGroupSaga() {
  yield takeEvery(createAssumptionGroup, function* ({ payload }) {
    try {
      yield put(setGroupsAreLoading(true));

      const url = '/api/assumptions/groups';
      const res = yield postWithToken(url, payload);
      const data = yield res.json();

      const selectedModule = yield select(selectedModuleSelector);
      if(selectedModule){
        const updatedGroups = [...selectedModule.groups, data];
        yield put(setSelectedModule({...selectedModule, groups: updatedGroups}));
      }
      
      yield put(setSelectedGroupId(data.groupId));
      yield put(setSelectedGroupIsOpen(true));
      yield put(setGroupsAreLoading(false));
      yield put(appNotify(`${payload.name} created`, 'success'));
    } catch (error) {
      yield put(
        appNotify(`Failed to create assumption group: ${error.message}`, 'error')
      );
      yield put(setGroupsAreLoading(false));
    }
  });
}
